/**
 * Форматирует отображаемое имя фитинга для комплектующих и спецификации.
 * Для прямых заглушек добавляет толщину из каталога (поле length).
 */
export function formatFittingDisplayName(itemKey, info) {
  if (info?.subcategory === 'Прямые' && info?.length) {
    const size = (info.displayName || itemKey)
      .replace(/^Заглушка прямая /, '')
      .replace(',', '.');
    return `Заглушка прямая ${size}(${info.length}мм)`;
  }
  return info?.displayName || itemKey;
}
